export const sortAlphabetically = (items, getKeys, locale) => {
  const collator = new Intl.Collator(locale, { sensitivity: "base", numeric: true });
  return [...items].sort((a, b) => {
    const keysA = getKeys(a);
    const keysB = getKeys(b);
    for (let i = 0; i < keysA.length; i++) {
      const result = collator.compare(keysA[i] || "", keysB[i] || "");
      if (result !== 0) return result;
    }
    return 0;
  });
};
